import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import {AuthService} from '../../../services/auth.service';
import {User} from '../../../dto/user';
import {navigation} from '../../../navigation/navigation';
import {FuseSidebarService} from '../../../../@fuse/components/sidebar/sidebar.service';
import {FuseConfigService} from '../../../../@fuse/services/config.service';
import {GeneralBroadcastService} from '../../../services/general-broadcast.service';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ToolbarComponent implements OnInit, OnDestroy {

    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    user = new User();
    loggedUser: User;
    private _unsubscribeAll: Subject<any>;
    opacity = 1;
    title = '';

    isChemistModule = false;
    isDoctorToolbar = false;
    isExpenseClaimToolbar = false;
    isHrToolbar = false;
    isKpiToolbar = false;
    isLocationToolbar = false;
    isOthersToolbar = false;
    isProductToolbar = false;
    isSalesAndCollectionToolbar = false;
    isSiteToolbar = false;
    isTeamToolbar = false;

    isAttendanceReportModule = false;
    isCallPlanReportModule = false;
    isDoctorOrderReportModule = false;
    isDoctorReportModule = false;
    isOrderReportModule = false;
    isDueReportModule = false;
    isSampleStockReportModule = false;
    isUserReportModule = false;



    constructor(private _fuseConfigService: FuseConfigService,
                private _fuseSidebarService: FuseSidebarService,
                private _translateService: TranslateService,
                private auth: AuthService,
                private router: Router,
                private generalBroadcastService: GeneralBroadcastService) {
        // Set the defaults
        this.loggedUser = auth.user;
        this.generalBroadcastService.sharedTitle.subscribe(values => {
            this.title = values;
        });
        this.generalBroadcastService.sharedModuleId.subscribe(pValue => {
            this.isChemistModule = pValue == 'CHEMIST';
            this.isDoctorToolbar = pValue == 'DOCTOR';
            this.isExpenseClaimToolbar = pValue == 'EXPENSE_CLAIM';
            this.isHrToolbar = pValue == 'HR';
            this.isKpiToolbar = pValue == 'KPI';
            this.isLocationToolbar = pValue == 'LOCATION';
            this.isOthersToolbar = pValue == 'OTHERS';
            this.isProductToolbar = pValue == 'PRODUCT';
            this.isSalesAndCollectionToolbar = pValue == 'ORDER';
            this.isSiteToolbar = pValue == 'SITE';
            this.isTeamToolbar = pValue == 'TEAM';

            this.isAttendanceReportModule = pValue == 'user_attendance_report';
            this.isCallPlanReportModule = pValue == 'doctor_visit_report';
            this.isDoctorOrderReportModule = pValue == 'DOCTOR_ORDER';
            this.isDoctorReportModule = pValue == 'doctor_report';
            this.isOrderReportModule = pValue == 'order_report';
            this.isDueReportModule = pValue == 'INVOICE';
            this.isSampleStockReportModule = pValue == 'sample_stock_report';
            this.isUserReportModule = pValue == 'user_report';

        });
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            }
        ];

        this.languages = [
            {
                id: 'en',
                title: 'English',
                flag: 'us'
            },
            {
                id: 'bn',
                title: 'Bengali',
                flag: 'bd'
            }
        ];

        this.navigation = navigation;

        this.user = this.auth.user;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, {id: this._translateService.currentLang});
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void {
        // Do your search here...
        console.log(value);
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }

    doLogout(event): void {
        event.preventDefault();

        this.auth.logout().subscribe(res => {
            if (res) {
                this.router.navigate(['auth/login']);
            }
        });
    }

    seeProfile(event): void {
        event.preventDefault();

        // this.auth.logout().subscribe( res => {
        //     if ( res ) {
        this.router.navigate(['user', this.user.Id, this.user.Code]);
        //     }
        // } );
    }
}
